import React from 'react';

const ContactUs: React.FC = () => {
     return (
          <div style={styles.container}>
               <h2>Contact Us</h2>
               <p style={styles.text}>
                    For any privacy-related concerns or questions, email us at:{" "}
                    <a href="mailto:contact@indeeclips.com">
                         contact@indeeclips.com
                    </a>
               </p>
          </div>
     );
};

const styles: { [key: string]: React.CSSProperties } = {
     container: {
          fontFamily: 'Arial, sans-serif',
          padding: '20px',
          maxWidth: '600px',
          margin: 'auto',
     },
     text: {
          fontSize: '16px',
          color: '#333',
     }
};

export default ContactUs;
